import React from "react";
import Banner from "../../../assets/images/banner.jpg";
import Image from "src/components/elements/Image";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "lucide-react";

const DashboardBanner = () => {
  return (
    <>
      <div className="relative z-0 flex flex-shrink flex-grow flex-col items-start justify-end overflow-hidden rounded-lg shadow">
        <div className="absolute inset-0 z-[-1] after:absolute after:inset-0 after:z-[0] after:bg-gradient-to-r after:from-white/80 after:to-white/20 after:content-['']">
          <Image
            src={Banner}
            alt={"Travel Image"}
            width={"100%"}
            height={"100%"}
            effect={"blur"}
            classes={"object-cover"}
          />
        </div>
        <div className="relative flex h-12 w-full items-center justify-between">
          <div className="decoration relative flex h-12 items-center justify-center pl-6 text-base font-medium text-white">Upcoming Trips</div>
          <div className="px-6">
            <Link
              to={"/"}
              className="flex items-center gap-x-2 text-sm font-semibold text-[#2D0B31]">
              View All Trips{" "}
              <ChevronRightIcon
                size={16}
                color={"currentColor"}
              />
            </Link>
          </div>
        </div>
        <div className="my-auto w-full space-y-2 px-8 py-8">
          <div className="text-3xl font-bold text-[#2D0B31]">London</div>
          <div className="text-lg font-semibold text-[#2D0B31]">July 5-8, 2026</div>
          <div className="flex">
            <div className="rounded-md bg-[#542f5d] px-2 py-1 text-sm font-medium text-white">In Policy</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardBanner;
